import {ReactElement} from 'react'
import {itHasToBeDisplayedForCountry} from './utils'
import {Container, Text, Title} from './styles'

type DepositInformationMessageProps = {
  country?: string
}

export function DepositInformationMessage(
  props: DepositInformationMessageProps,
): ReactElement | null {
  const {country} = props

  if (country != null && !itHasToBeDisplayedForCountry(country)) return null

  return (
    <Container>
      <Title>Important:</Title>
      <Text>
        When making a crypto deposit, please make sure to deposit the exact total amount to avoid
        any errors or processing issues.
      </Text>
    </Container>
  )
}
